export default __webpack_public_path__ + "locales/el-GR/Settings.json?hash=d07a029e663ea64e5496fe73266bb00a";